import React from 'react'

export default (Component, event) => {
  return class extends React.Component {
    constructor(props) {
      super(props)
      this.onClickOutside = event(props)
    }

    componentDidMount() {
      document.addEventListener('mouseup', this.handleClick, false)
    }

    componentWillUnmount() {
      document.removeEventListener('mouseup', this.handleClick, false)
    }

    handleClick = e => {
      if(this.node.contains(e.target)) return

      this.onClickOutside()
    }

    render() {
      return (
        <div ref={node => this.node = node}>
          <Component {...this.props} />
        </div>
      )
    }
  }
}